import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import './AdminProfessionalInfo.css';

function AdminCNCOperatorFields({ formData, setFormData }) {
    const updateField = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

    const toggleArrayField = (field, item) => {
        const currentArray = Array.isArray(formData[field]) ? formData[field] : [];
        if (currentArray.includes(item)) {
            updateField(field, currentArray.filter(i => i !== item));
        } else {
            updateField(field, [...currentArray, item]);
        }
    };

    // Data arrays (same as ProfessionalInfo.js CNC Operator)
    const cncOperatorPositions = [
        "CNC Operator – Turning", "CNC Operator – Milling", "VMC Operator",
        "HMC Operator", "5-Axis Operator", "CNC Machine Setter"
    ];
    const cncOperatorIndustries = [
        "Manufacturing", "Automotive", "Oil & Gas",
        "Aerospace", "Metal Fabrication", "Other"
    ];
    const cncOperatorControlsList = [
        "FANUC", "Siemens", "Heidenhain", "Mitsubishi",
        "Haas", "Mazak", "Okuma", "Other"
    ];
    const cncOperatorMachinesList = [
        "CNC Lathe", "CNC Milling", "VMC", "HMC", "5-Axis", "Swiss Type"
    ];
    const cncOperatorTechnicalSkills = [
        "Tool Setting", "Offset Setting", "Tool Change",
        "Reading Engineering Drawings", "Basic G-Code Understanding",
        "Quality Inspection (Vernier / Micrometer)", "Basic Maintenance",
        "Production Target Handling"
    ];
    const cncOperatorSoftwareKnowledge = [
        "Mastercam", "SolidCAM", "UG NX", "Fusion 360", "None"
    ];

    // Dropdown states
    const [controlsOpen, setControlsOpen] = useState(false);
    const [controlsSearch, setControlsSearch] = useState('');
    const [machinesOpen, setMachinesOpen] = useState(false);
    const [machinesSearch, setMachinesSearch] = useState('');
    const [skillsOpen, setSkillsOpen] = useState(false);
    const [skillsSearch, setSkillsSearch] = useState('');
    const [softwareOpen, setSoftwareOpen] = useState(false);
    const [softwareSearch, setSoftwareSearch] = useState('');

    const cnc_controls = Array.isArray(formData.cnc_controls) ? formData.cnc_controls : [];
    const machines_operated = Array.isArray(formData.machines_operated) ? formData.machines_operated : [];
    const technical_skills = Array.isArray(formData.technical_skills) ? formData.technical_skills : [];
    const software_knowledge = Array.isArray(formData.software_knowledge) ? formData.software_knowledge : [];

    const predefinedIndustries = ["Manufacturing", "Automotive", "Oil & Gas", "Aerospace", "Metal Fabrication"];
    const isOtherIndustry = formData.industry_experience && !predefinedIndustries.includes(formData.industry_experience);

    const MultiSelectDropdown = ({ id, title, options, selectedValues, field, isOpen, setIsOpen, search, setSearch }) => {
        const filtered = options.filter(o => o.toLowerCase().includes(search.toLowerCase()));
        return (
            <Dropdown show={isOpen} onToggle={(open) => setIsOpen(open)} className="mb-3">
                <Dropdown.Toggle variant="light" className="language-select w-100 d-flex justify-content-between align-items-center" id={id}>
                    <span style={{ color: selectedValues.length > 0 ? '#212529' : '#6c757d' }}>
                        {selectedValues.length > 0 ? `${title} (${selectedValues.length} selected)` : title}
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                    <div className="px-2 py-1">
                        <Form.Control type="text" placeholder={`Search...`} value={search} onChange={(e) => setSearch(e.target.value)} onClick={(e) => e.stopPropagation()} className="mb-2" autoFocus />
                    </div>
                    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        {filtered.map((opt) => (
                            <Dropdown.Item key={opt} active={selectedValues.includes(opt)} onClick={() => toggleArrayField(field, opt)}>{opt}</Dropdown.Item>
                        ))}
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    return (
        <>
            {/* Position Applying For */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Position Applying For *</h4>
                <Row className="g-3 mb-3">
                    {cncOperatorPositions.map((opt, idx) => (
                        <Col xs={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${formData.cnc_operator_position === opt ? 'selected-button' : ''}`} onClick={() => updateField('cnc_operator_position', opt)}>{opt}</Button>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Industry */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Industry *</h4>
                <Row className="g-3 mb-3">
                    {cncOperatorIndustries.map((opt, idx) => {
                        const isSelected = opt === 'Other' ? isOtherIndustry : formData.industry_experience === opt;
                        return (
                            <Col xs={6} md={4} key={idx}>
                                <Button variant="light" className={`language-btn jobtype-btn w-100 ${isSelected ? 'selected-button' : ''}`}
                                    onClick={() => {
                                        if (opt === 'Other') {
                                            if (!isOtherIndustry) updateField('industry_experience', 'Other');
                                        } else {
                                            updateField('industry_experience', opt);
                                        }
                                    }}>
                                    {opt}
                                </Button>
                            </Col>
                        );
                    })}
                </Row>
                {isOtherIndustry && (
                    <div className="mt-3">
                        <Form.Control
                            type="text"
                            placeholder="Other Industry Experience (Type here)"
                            className="professional-input"
                            value={formData.industry_experience === 'Other' ? '' : formData.industry_experience}
                            onChange={(e) => updateField('industry_experience', e.target.value)}
                            autoFocus
                        />
                    </div>
                )}
            </div>

            {/* Machine Knowledge */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Machine Knowledge</h4>
                <MultiSelectDropdown id="dd-op-controls" title="Select CNC Controls" options={cncOperatorControlsList} selectedValues={cnc_controls} field="cnc_controls" isOpen={controlsOpen} setIsOpen={setControlsOpen} search={controlsSearch} setSearch={setControlsSearch} />
                {cnc_controls.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {cnc_controls.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('cnc_controls', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
                <MultiSelectDropdown id="dd-op-machines" title="Select CNC Machines" options={cncOperatorMachinesList} selectedValues={machines_operated} field="machines_operated" isOpen={machinesOpen} setIsOpen={setMachinesOpen} search={machinesSearch} setSearch={setMachinesSearch} />
                {machines_operated.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {machines_operated.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('machines_operated', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Technical Skills */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Technical Skills</h4>
                <MultiSelectDropdown id="dd-op-skills" title="Select Technical Skills" options={cncOperatorTechnicalSkills} selectedValues={technical_skills} field="technical_skills" isOpen={skillsOpen} setIsOpen={setSkillsOpen} search={skillsSearch} setSearch={setSkillsSearch} />
                {technical_skills.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {technical_skills.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('technical_skills', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Software Knowledge */}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Software Knowledge (if any)</h4>
                <MultiSelectDropdown id="dd-op-software" title="Select Software Knowledge" options={cncOperatorSoftwareKnowledge} selectedValues={software_knowledge} field="software_knowledge" isOpen={softwareOpen} setIsOpen={setSoftwareOpen} search={softwareSearch} setSearch={setSoftwareSearch} />
                {software_knowledge.length > 0 && (
                    <div className="mt-2 mb-3 d-flex flex-wrap gap-2">
                        {software_knowledge.map((item, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {item}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('software_knowledge', item)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default AdminCNCOperatorFields;
